import * as Types from '../../../graphql';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetNewZoneFeaturesQueryVariables = Types.Exact<{
  zoneCode?: Types.InputMaybe<Types.Scalars['String']>;
  appVersion?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetNewZoneFeaturesQuery = { __typename?: 'Query', auth?: { __typename?: 'auth', getNewZoneFeaturesUsingGET?: { __typename?: 'auth_ZoneFeaturesResponse', zoneCode?: string | null, hasNewFeatures?: boolean | null, features?: Array<{ __typename?: 'auth_AppZoneFeatureRepresentation', externalId?: string | null, zoneCode?: string | null, title?: string | null, description?: string | null, displayOrder?: number | null, introducedInAppVersion?: number | null, iconUrl?: string | null, iconBackgroundColor?: string | null, featureBackgroundColor?: string | null }> | null } | null } | null };

export type MarkZoneFeaturesAsSeenMutationVariables = Types.Exact<{
  zoneCode?: Types.InputMaybe<Types.Scalars['String']>;
  appVersion?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type MarkZoneFeaturesAsSeenMutation = { __typename?: 'Mutation', auth?: { __typename?: 'auth_mutation', markZoneFeaturesAsSeenUsingPOST?: any | null } | null };

export const GetNewZoneFeaturesDocument = gql`
    query getNewZoneFeatures($zoneCode: String, $appVersion: Int) {
  auth {
    getNewZoneFeaturesUsingGET(zoneCode: $zoneCode, appVersion: $appVersion) {
      zoneCode
      hasNewFeatures
      features {
        externalId
        zoneCode
        title
        description
        displayOrder
        introducedInAppVersion
        iconUrl
        iconBackgroundColor
        featureBackgroundColor
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNewZoneFeaturesGQL extends Apollo.Query<GetNewZoneFeaturesQuery, GetNewZoneFeaturesQueryVariables> {
    document = GetNewZoneFeaturesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkZoneFeaturesAsSeenDocument = gql`
    mutation markZoneFeaturesAsSeen($zoneCode: String, $appVersion: Int) {
  auth {
    markZoneFeaturesAsSeenUsingPOST(zoneCode: $zoneCode, appVersion: $appVersion)
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkZoneFeaturesAsSeenGQL extends Apollo.Mutation<MarkZoneFeaturesAsSeenMutation, MarkZoneFeaturesAsSeenMutationVariables> {
    document = MarkZoneFeaturesAsSeenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }